import { mutations } from "@/constants/state";

export default {
  [mutations.DOMAIN_FETCH_MUTATION]: (state, payload) => {
    state.domain = payload;
  },
};
